import Contact from '@/plugins/sdk/resources/Account/Contact'

export default class extends Contact {
  static name = 'accountcontact'
}
